import Vue from 'vue'
import Vuex from 'vuex'
import converter from 'number-to-words'
import axios from 'axios'

Vue.use(Vuex)

const home = {

    state: {
        currentKey: 'one',
        dataRaw: [],
        inView: false,
    },

    actions: {
        setCurrentKey ({ commit }, key) {
            commit('updateCurrentKey', key)
        },
        setInView ({ commit }, key) {
            commit('updateInView', key)
        },
        async getImpact({ commit }) {
            var lang = document.querySelector('html').getAttribute('data-sitehandle');
            if (!this.state.dataRaw || this.state.dataRaw.length == 0) {
                const resp = await axios.get('/' + lang + '/homepageImpact.json')
                commit('setImpact', resp.data)
            }
        }
    },

    mutations: {
        updateCurrentKey (state, key) {
            state.currentKey = key
        },
        updateInView (state, key) {
            state.inView = key
        },
        setImpact (state, data) {
            state.dataRaw = data
            console.log(data)
           
        }
    },

    getters: {
        keyedData (state) {
            const obj = {}

            state.dataRaw.forEach((data, index) => {
                const convertedNumber = converter.toWords(index + 1)

                obj[convertedNumber] = data
            })

            return obj
        },

        currentData (state, getters) {
            return getters.keyedData[state.currentKey]
        },

        currentLabel(state, getters) {
            return this.$store.getters.keyedData[state.dataRaw.title]
        },

        getTitle: (state) => (index) => {
            return state.dataRaw[index].title
        },

        allImages (state) {
            const imageObjects = state.dataRaw.map(data => data.images).flat()

            imageObjects.forEach(imageObject => {
                const image = new Image()
                image.src = imageObject.url
                imageObject.id = Math.random().toString(36).substr(2)
            })

            return imageObjects
        },
    },

}

export default home
